export default __webpack_public_path__ + "static/media/nexus-mutual-logo.d3ee1f0e.svg";